
export default function SymbolAvgVoltage({id, fontSize, txtColor, overlineColor}) {
    return (<symbol id={id} viewBox="0 0 24 20">
        <text
            x={4}
            y={20}
            // dominantBaseline="middle"
            // textAnchor="middle"
            fontSize={fontSize??"20"}
            // fontFamily="Arial, sans-serif"
            fill={txtColor??"black"}
        >V</text>
        <line x1={3} y1={1} x2={18} y2={1} stroke={overlineColor??"green"} strokeWidth="2" textAnchor="end" dominantBaseline="text-before-edge"/>
    </symbol>);
}